{

    let selector='textarea[maxlength]:not(.vut-wysiwyg), textarea[data-maxbytes]:not(.vut-wysiwyg)';
    let selectorBar='.-textarea-maxlength-bar'

    document.head.insertAdjacentHTML('beforeend', 
        '<style>'
            +'.-textarea-maxlength-bar {position:absolute; height:7px; padding:0px; margin-top:-2px; background-color:white; border-top:none !important; position:relative; cursor:help}'
            +'.-textarea-maxlength-bar>.-textarea-maxlength-indicator {overflow:hidden; width:0px; height:100%; position:relative;}'
            +selector+'{padding-bottom:12px;}'
        +'</style>'
    );

    window.initTextareaCounter=function(){
        let ta=document.querySelectorAll(selector);
        for (let i=0, l=ta.length; i<l; i++) {
            doBar(ta[i]);
        }
    }

    function input(event) {
        if (event.target.matches(selector)) {
            if (event.target.nextElementSibling && event.target.nextElementSibling.matches(selectorBar)) {
                doBar(event.target);
            }
        }
    }

    function mousemove(event) {
        if ((event.buttons==1)&&(event.target instanceof HTMLElement)&&event.target.matches(selector)) {
            if (event.target.nextElementSibling && event.target.nextElementSibling.matches(selectorBar)) {
                event.target.nextElementSibling.style.width=event.target.getBoundingClientRect().width+'px';
                event.target.nextElementSibling.style.border=getComputedStyle(event.target).border;
            }
        }
    }

    function resize() {
        let ta=document.querySelectorAll(selector);
        for (let i=0, l=ta.length; i<l; i++) {
            let bar=ta[i].nextElementSibling;
            if (bar&&bar.matches('.-textarea-maxlength-bar')) {
                bar.style.width=ta[i].getBoundingClientRect().width+'px';
                bar.style.border=getComputedStyle(ta[i]).border;
            }
        }        
    }

    function doBar(textarea) {

        setTimeout(function(){

            let bar;
            if (
                textarea&&textarea.matches(selector)&&
                (
                    (textarea.maxLength&&(parseInt(textarea.maxLength)>0))
                    ||(textarea.dataset.maxbytes&&(parseInt(textarea.dataset.maxbytes)>0)) 
                )                
            ) {
                
                if (!((bar=textarea.nextElementSibling)&&bar.matches(selectorBar))) {
                    bar=document.createElement('div');
                    bar.className='-textarea-maxlength-bar';
                    textarea.insertAdjacentElement('afterend', bar);
                }

                let length, pct;

                let valueCRLF = textarea.value.replace(/(\r\n|\r\n|\n|\r)/g, '\r\n');

                if (textarea.maxLength&&(parseInt(textarea.maxLength)>0)) {
                    length=valueCRLF.length;
                    pct=100/parseInt(textarea.maxLength)*length;
                    if (textarea.dataset.maxbytes&&(parseInt(textarea.dataset.maxbytes)>0)) {console.warn("textarea: element ", textarea, "má nastaveno maxLengt, data-maxbytes je ignorováno.")}
                } else {
                    try { // pokus o přepočet délky textu na byte
                        length = (new Blob([valueCRLF]).size);
                    } catch(e) {
                        length=valueCRLF.length;
                    };
                    pct=100/parseInt(textarea.dataset.maxbytes)*length;
                }
                let red, green, blue=0;
                let title;
                if (pct<=100) {
                    red=Math.round(128*Math.pow(pct/100, 3)+127);
                    green=Math.round(127);
                    blue=Math.round(128-(128*Math.pow(pct/100, 3)));
                    textarea.style.border="";
                    bar.style.border="";
                    title=window.gl_lang_code=='cs'
                        ?'Zadáno '+Math.floor(pct)+'% maximální délky textu.'
                        :Math.floor(pct)+'% of the maximum text length entered.';
                    if ((pct==100)&&((parseFloat(textarea.dataset.pct))<100)) {
                        setTimeout(function(){alert(
                            window.gl_lang_code=='cs'
                                ?'Dosažena maximální povolená délka textu.'
                                :'Maximum text length reached.'                       
                        );}, 5); 
                    }

                } else {
                    red=255;
                    green=0;
                    textarea.style.border="1px solid red";
                    bar.style.border="1px solid red";
                    title=window.gl_lang_code=='cs'
                        ?'Překročena povolená délka textu.'
                        :'Maximum text length exceeded.';
                }
                //bar.style.backgroundColor='rgb('+(red)+', '+(green)+', 0)';
                //bar.style.paddingLeft=pct+'%';
                bar.innerHTML='<div class="-textarea-maxlength-indicator" style="padding-left:'+Math.min(pct, 100)+'%; background-color:rgb('+(red)+', '+(green)+', '+(blue)+');">';
                bar.title=title;
                textarea.dataset.pct=pct;
                bar.style.width=textarea.getBoundingClientRect().width+'px';
                bar.style.border=getComputedStyle(textarea).border;
            }

        }, 5);

    }

    let focusblur=() =>{
        // plynulý přechod barvy rámečku ...
        for (let i=50; i<351; i+=50) setTimeout(resize, i);
    }

    window.addEventListener('input', input, true);
    window.addEventListener('mouseup', input, true);
    window.addEventListener('mousemove', mousemove, true);
    window.addEventListener('resize', resize, true);
    window.addEventListener('focus', focusblur, true);
    window.addEventListener('blur', focusblur, true);

};

window.addEventListener('DOMContentLoaded', initTextareaCounter, true);